{
  "newTitle": "New post",
  "editTitle": "Edit post",
  "lastEdited": "Last edited {date}",
  "contributorReadOnly": "Contributors can edit only their own drafts. Ask an editor to change this post.",
  "archivedTitle": "This post is archived. Restore it to edit.",
  "unarchive": "Restore as draft",
  "unarchivedToast": "Restored as a draft.",
  "returnedTitle": "An editor asked for changes",
  "pendingTitle": "Waiting for approval",
  "pendingEditorBody": "{name} sent this for approval. Review it, then publish or return it with a note.",
  "pendingContributorBody": "An editor will review this. You can still make changes.",
  "cancelledTitle": "This event was cancelled",
  "sectionType": "Type of post",
  "typeAnnouncementHint": "A notice or advisory",
  "typeScheduleHint": "Happens on a date, maybe repeating",
  "typeProgramHint": "An activity people can join or register for",
  "sectionContent": "What",
  "title": "Title",
  "titleHint": "Short and clear, e.g. \"Free anti-rabies vaccination\".",
  "titleRequired": "Add a title of at least 3 characters.",
  "category": "Category",
  "noCategory": "No category",
  "body": "Details",
  "bodyHint": "What residents need to know: what to bring, who can join, fees.",
  "formatting": "Formatting",
  "bold": "Bold",
  "italic": "Italic",
  "underline": "Underline",
  "heading": "Heading",
  "bulletList": "Bulleted list",
  "numberedList": "Numbered list",
  "quote": "Quote",
  "link": "Link",
  "linkPrompt": "Link address (leave empty to remove the link)",
  "undo": "Undo",
  "redo": "Redo",
  "cover": "Cover image",
  "coverHint": "Optional. Shown on the post and when the link is shared on Facebook.",
  "coverAlt": "Cover image preview",
  "addCover": "Add cover image",
  "replaceCover": "Replace",
  "removeCover": "Remove",
  "uploading": "Uploading…",
  "attachments": "Attachments",
  "attachmentsHint": "PDF or images, up to 10 files of 2 MB each (e.g. forms or guidelines).",
  "addAttachment": "Add file",
  "attachmentName": "Name of attachment {n}",
  "removeAttachment": "Remove {name}",
  "image": "Image",
  "sectionWhen": "When",
  "timingMode": "Dates",
  "timingSingle": "One date",
  "timingSessions": "Several dates or time slots",
  "allDay": "All day",
  "starts": "Starts",
  "ends": "Ends",
  "endsHint": "Optional. Same day if you only set a time.",
  "endsAllDayHint": "Optional, for events lasting several days.",
  "repeats": "Repeats",
  "repeatFreq": "How often",
  "repeatNone": "Does not repeat",
  "repeatDaily": "Daily",
  "repeatWeekly": "Weekly",
  "repeatMonthly": "Monthly",
  "every_days": "Every how many days",
  "every_weeks": "Every how many weeks",
  "every_months": "Every how many months",
  "onDays": "On these days",
  "day_MO": "Mon",
  "day_TU": "Tue",
  "day_WE": "Wed",
  "day_TH": "Thu",
  "day_FR": "Fri",
  "day_SA": "Sat",
  "day_SU": "Sun",
  "monthlyOn": "Monthly on",
  "monthlyDay": "Day {day} of the month",
  "monthlyNth": "The same weekday each month",
  "whichWeek": "Which one",
  "sameWeekday": "Uses the start date's weekday ({day}).",
  "ordinal_1": "First",
  "ordinal_2": "Second",
  "ordinal_3": "Third",
  "ordinal_4": "Fourth",
  "ordinal_last": "Last",
  "repeatEnds": "Ends",
  "endsNever": "No end date",
  "endsOn": "On a date",
  "endsAfter": "After a number of times",
  "lastDate": "Last date",
  "times": "Number of times",
  "repeatSummary": "Summary:",
  "repeatNeedsStart": "Set the start date first.",
  "sessions": "Dates and time slots",
  "sessionsHint": "Residents choose one when they register. Each can have its own number of slots.",
  "noSessions": "No dates yet.",
  "sessionN": "Date {n}",
  "sessionLabel": "Label",
  "sessionLabelPlaceholder": "e.g. Morning batch",
  "startTime": "Start",
  "endTime": "End",
  "slotCapacity": "Slots",
  "noLimit": "No limit",
  "endAfterStart": "The end time must be after the start time.",
  "addSession": "Add date or time slot",
  "duplicateSession": "Copy date {n}",
  "removeSession": "Remove date {n}",
  "removeSessionWithRegs": "{count} people registered for this date. Removing it cancels the date and notifies them. Continue?",
  "cancelSession": "Cancel this date (registrants are notified)",
  "registeredInSession": "{count} registered",
  "sectionWhere": "Where",
  "venueName": "Venue",
  "venuePlaceholder": "e.g. Municipal Gymnasium",
  "venueBarangay": "Barangay of the venue",
  "noBarangay": "Not set",
  "venueAddress": "Address or directions",
  "mapPin": "Map pin",
  "mapPinHint": "Drag the pin or tap the map. Residents get a \"Get directions\" button.",
  "addPin": "Add a map pin",
  "addPinHint": "Optional. Lets residents get directions.",
  "removePin": "Remove pin",
  "sectionAudience": "Who it's for",
  "audienceTown": "Whole town",
  "audienceBarangays": "Selected barangays",
  "chooseBarangays": "Barangays",
  "eligibility": "Who can join",
  "eligibilityHint": "Optional, e.g. \"Senior citizens 60+\" or \"Registered farmers (RSBSA)\".",
  "sectionRegistration": "Registration",
  "takeRegistrations": "Take registrations in the app",
  "takeRegistrationsHint": "Residents register in a few taps and get a QR ticket. No Google Forms needed.",
  "formFields": "Questions on the form",
  "formFieldsHint": "Name, mobile and other profile details are filled in from the resident's account.",
  "fromProfile": "Filled in from the resident's profile",
  "fieldLabel": "Label",
  "requiredField": "Required",
  "choices": "Choices",
  "choicesHint": "One choice per line.",
  "moveUp": "Move {name} up",
  "moveDown": "Move {name} down",
  "removeField": "Remove {name}",
  "consentField": "Privacy consent",
  "consentFieldHint": "Always included (Data Privacy Act, RA 10173).",
  "addField": "Add question",
  "chooseField": "Choose a question to add",
  "builtInFields": "From the resident's profile",
  "customFields": "Your own question",
  "kind_name": "Full name",
  "kind_mobile": "Mobile number",
  "kind_email": "Email",
  "kind_barangay": "Barangay",
  "kind_address": "Address",
  "kind_birthdate": "Birthdate",
  "kind_age": "Age",
  "kind_sex": "Sex",
  "kind_rsbsa": "RSBSA number",
  "kind_senior_pwd_id": "Senior citizen / PWD ID number",
  "kind_school": "School",
  "kind_companions": "Number of companions",
  "kind_text": "Short answer",
  "kind_dropdown": "Dropdown",
  "kind_checkbox": "Checkbox",
  "kind_file": "File upload",
  "kindType_text": "Short answer",
  "kindType_dropdown": "Dropdown (pick one)",
  "kindType_checkbox": "Checkbox (yes / no)",
  "kindType_file": "File upload (photo or PDF)",
  "capacity": "Slots",
  "capacityHint": "Leave empty for no limit. Companions take a slot too.",
  "totalCapacity": "Overall slots",
  "totalCapacityHint": "Optional limit across all dates. Each date can also have its own.",
  "cancelCutoff": "Cancellation cutoff (hours)",
  "cancelCutoffHint": "Residents can cancel until this many hours before it starts. 0 = any time.",
  "opens": "Registration opens",
  "opensHint": "Leave empty to open when published.",
  "closes": "Registration closes",
  "closesHint": "Leave empty to keep it open until the event.",
  "waitlist": "Waitlist when full",
  "waitlistHint": "People join a waitlist and move up automatically when someone cancels.",
  "approval": "Approve each registration",
  "approvalHint": "Registrations wait for an editor to approve or decline (e.g. scholarships).",
  "onePerAccount": "One registration per account",
  "onePerAccountHint": "Turn off if one person may register others (e.g. family members).",
  "smsReminders": "SMS reminder the day before",
  "smsRemindersHint": "Also texts registrants who gave a mobile number.",
  "smsNotConfigured": "SMS isn't set up yet, so reminders go by app notification only.",
  "sectionPublishing": "Publishing",
  "publishAt": "Publish on",
  "publishAtHint": "Leave empty to publish right away.",
  "expiresAt": "Hide after",
  "expiresAtHint": "Optional. The post leaves the feed after this date.",
  "pinned": "Pin to top",
  "pinnedHint": "Keeps it at the top of your office page and the feed.",
  "urgent": "Urgent town-wide alert",
  "urgentHint": "Shown first to everyone, in the emergency color. Use only for real urgent advisories.",
  "history": "Edit history",
  "edited": "Edited",
  "scheduleChangedBadge": "Date or venue changed",
  "willNotify": "You changed the date, time or venue. Everyone registered will be notified when you save.",
  "saveDraft": "Save draft",
  "submitForApproval": "Send for approval",
  "publish": "Publish",
  "schedulePublish": "Schedule",
  "saveChanges": "Save changes",
  "fixErrors": "Please fix the highlighted fields.",
  "savedToast": "Saved.",
  "submittedToast": "Sent for approval.",
  "publishedToast": "Published. Followers are being notified.",
  "scheduledToast": "Scheduled. It will publish on the date you set.",
  "cancelEvent": "Cancel event",
  "cancelEventTitle": "Cancel this event?",
  "cancelEventLead": "The post stays visible, marked \"Cancelled\", and everyone registered is notified with your reason.",
  "cancelReason": "Reason",
  "cancelReasonRequired": "Give a short reason residents will see.",
  "confirmCancelEvent": "Cancel event and notify",
  "cancelledToast": "Event cancelled. Registrants are being notified.",
  "archive": "Archive",
  "confirmArchive": "Archive this post? It disappears from the feed but stays in your records.",
  "archivedToast": "Archived.",
  "deleteDraft": "Delete draft",
  "confirmDelete": "Delete this draft permanently?",
  "deletedToast": "Draft deleted.",
  "alwaysRequired": "Always required here."
}
